import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Paper } from '@mui/material';
import Grid from 'material/components/Grid';

import {
  fetchBroadcast,
  fetchBroadcastLinks,
  fetchBroadcastRecipients,
} from 'store/actions/broadcasts';
import { broadcastsSelectors } from 'store/selectors/broadcasts';

import {
  Backdrop,
  BreadcrumbsNavigation,
  Container,
  LinksTable,
  RecipientsTable,
  TabPanel,
  Tabs,
} from 'common/components';
import { CardWrapper } from 'globalStyles';

import BroadcastTopCard from '../components/BroadcastTopCard';
import BroadcastOverview from '../components/BroadcastOverview';

const StyledPaper = styled(Paper)`
  border-bottom: 0;
`;

const BroadcastDetails = () => {
  const dispatch = useDispatch();
  const { broadcastUuid, organizationUuid } = useParams();

  const {
    broadcastDetails,
    broadcastLinks,
    broadcastRecipients,
    isBroadcastFetching,
    isBroadcastLinksFetching,
    isBroadcastRecipientsFetching,
  } = useSelector(state => ({
    broadcastDetails: broadcastsSelectors.getBroadcastDetails(state),
    broadcastLinks: broadcastsSelectors.getBroadcastLinks(state),
    broadcastRecipients: broadcastsSelectors.getBroadcastRecipients(state),
    isBroadcastFetching: broadcastsSelectors.isBroadcastFetching(state),
    isBroadcastLinksFetching: broadcastsSelectors.isBroadcastLinksFetching(state),
    isBroadcastRecipientsFetching: broadcastsSelectors.isBroadcastRecipientsFetching(state),
  }));

  useEffect(() => {
    dispatch(fetchBroadcast(broadcastUuid));
    dispatch(fetchBroadcastLinks(broadcastUuid));
  }, []);

  const [tabIndex, setTabIndex] = useState('links');

  const { name } = broadcastDetails;

  const firstFetch = useRef({
    recipients: false,
  });

  const handleChangeTablesTab = newValue => {
    setTabIndex(newValue);

    if (newValue === 'recipients' && !firstFetch.current.recipients) {
      dispatch(fetchBroadcastRecipients(broadcastUuid)).then(() => {
        firstFetch.current.recipients = true;
      });
    }
  };

  const broadcastTabs = [
    {
      label: 'Links',
      value: 'links',
    },
    {
      label: 'Recipients',
      value: 'recipients',
    },
  ];

  const breadcrumbs = [
    {
      link: `/${organizationUuid}/broadcasts`,
      name: 'Broadcasts - All messages',
    },
    {
      link: '',
      name,
    },
  ];

  return (
    <>
      <BreadcrumbsNavigation links={breadcrumbs} />
      <Container>
        <Grid container>
          <BroadcastTopCard />
        </Grid>
        <Grid container>
          <BroadcastOverview />
        </Grid>
        <CardWrapper>
          <StyledPaper square variant="outlined">
            <Tabs handleSetTab={handleChangeTablesTab} tabs={broadcastTabs} tabIndex={tabIndex} />
          </StyledPaper>
          <TabPanel index={broadcastTabs[0].value} value={tabIndex}>
            <LinksTable links={broadcastLinks} isDataFetching={isBroadcastLinksFetching} />
          </TabPanel>
          <TabPanel index={broadcastTabs[1].value} value={tabIndex}>
            <RecipientsTable
              recipients={broadcastRecipients}
              isDataFetching={isBroadcastRecipientsFetching}
            />
          </TabPanel>
        </CardWrapper>
        <Backdrop isOpen={isBroadcastFetching} />
      </Container>
    </>
  );
};

export default BroadcastDetails;
